import { useState } from "react";
import ContentField from "./ContentField";
import InfoBlocksEditor from "./InfoBlocksEditor";

const LABELS = {
  plat_panel_overline: "Panel · Overline", plat_panel_greeting: "Panel · Saludo ({name} = nombre)",
  plat_birth_overline: "Datos natales · Overline", plat_birth_title: "Datos natales · Título",
  plat_chart_overline: "Carta natal · Overline",
  plat_docs_overline: "Documentos · Overline", plat_docs_title: "Documentos · Título", plat_docs_empty: "Documentos · Sin documentos",
  plat_transits_overline: "Tránsitos · Overline", plat_transits_title: "Tránsitos · Título",
  plat_transits_button: "Tránsitos · Botón para abrir", plat_transits_info_label: "Tránsitos · Desplegable explicativo",
  plat_transits_now_title: "Tránsitos de hoy · Título", plat_transits_now_intro: "Tránsitos de hoy · Introducción",
  plat_timeline_title: "Línea de tránsitos · Título", plat_timeline_soon_title: "Línea · Próximos 6 meses",
  plat_timeline_later_title: "Línea · De 6 a 12 meses", plat_ingress_title: "Ingresos a casas · Título",
  plat_save_overline: "Calculadora · Overline invitación", plat_save_title: "Calculadora · Título invitación",
  plat_save_body: "Calculadora · Texto invitación", plat_save_cta: "Calculadora · Botón crear cuenta",
  plat_register_title: "Registro · Título", plat_login_title: "Entrar · Título",
  plat_email_verify_subject: "Confirmación · Asunto", plat_email_verify_body: "Confirmación · Texto",
  plat_email_verify_cta: "Confirmación · Botón", plat_email_reset_subject: "Recuperar · Asunto",
  plat_email_reset_body: "Recuperar · Texto", plat_email_reset_cta: "Recuperar · Botón",
  plat_email_doc_subject: "Nuevo PDF · Asunto ({title} = título)", plat_email_doc_body: "Nuevo PDF · Texto ({name}, {title})",
  plat_email_doc_cta: "Nuevo PDF · Botón",
};

const TABS = [
  ["info", "¿Qué significa? (textos e imágenes)", null],
  ["transitos", "Tránsitos", ["plat_transits_", "plat_timeline_", "plat_ingress_"]],
  ["panel", "Panel y documentos", ["plat_panel_", "plat_birth_", "plat_chart_", "plat_docs_"]],
  ["registro", "Registro y calculadora", ["plat_save_", "plat_register_", "plat_login_"]],
  ["correos", "Correos a usuarios", ["plat_email_"]],
];

export default function PlatformAdmin({ defaults, values, onSave, onReset }) {
  const [sub, setSub] = useState("info");
  const prefixes = TABS.find((t) => t[0] === sub)[2];
  const keys = prefixes ? Object.keys(defaults).filter((k) => prefixes.some((p) => k.startsWith(p))) : [];

  return (
    <div data-testid="platform-admin" className="space-y-6">
      <p className="text-zinc-400 text-sm">Todo lo que ven tus usuarios en su cuenta: panel, tránsitos, registro y correos.</p>
      <div className="flex flex-wrap gap-2">
        {TABS.map(([id, label]) => (
          <button key={id} data-testid={`platform-tab-${id}`} onClick={() => setSub(id)}
            className={`px-4 py-2 text-sm border transition-colors ${sub === id ? "border-[#C9A25E] text-[#C9A25E]" : "border-white/10 text-zinc-400 hover:text-white"}`}>
            {label}
          </button>
        ))}
      </div>
      <div className="card">
        {sub === "info" ? <InfoBlocksEditor /> : keys.map((k) => (
          <ContentField key={k} k={k} label={LABELS[k] || k} defaultVal={defaults[k]}
            currentVal={values[k] ?? defaults[k]} onSave={onSave} onReset={onReset} />
        ))}
      </div>
    </div>
  );
}
